import React from 'react';
import PropTypes from 'prop-types';
import I18n from 'utils/I18n';

const ACTIVITY_LIST = [
  'ebikeride',
  'ride',
  'run',
  'swim',
  'virtualrun',
  'virtualride'
];

// 4/26 - On web, 3 types of cumulative goals can be set from the athletes profile
// Swim, Run, Ride - time and distance
// (eg of cumulative goal achievement- Strava Athlete accomplished their swimming goal)
const CumulativeGoalAchievement = ({
  cumulativeGoalAchievement,
  activityType,
  athleteFirstName
}) => {
  // Generate translation key for achievement summary - cumulative goal
  const displayKey = (() => {
    const prefix =
      'components.feed.activity_goal_accomplished.goal_accomplished.without_popup';
    const lowercaseType = activityType.toLowerCase();
    return `${prefix}.${lowercaseType}.neutral_html`;
  })();

  return (
    <>
      {cumulativeGoalAchievement &&
        ACTIVITY_LIST.includes(activityType.toLowerCase()) && (
          <li data-testid="cumulative_goal_achieved">
            {I18n.t(displayKey, {
              athlete: athleteFirstName
            })}
          </li>
        )}
    </>
  );
};

CumulativeGoalAchievement.propTypes = {
  cumulativeGoalAchievement: PropTypes.shape({
    activityType: PropTypes.string,
    amount: PropTypes.string
  }),
  activityType: PropTypes.string,
  athleteFirstName: PropTypes.string
};

CumulativeGoalAchievement.defaultProps = {
  cumulativeGoalAchievement: null,
  activityType: '',
  athleteFirstName: ''
};

export default CumulativeGoalAchievement;
